"use client";

import Image from "next/image";
import Flex from "@/shared/components/common/Flex";
import data from "@/public/data/landing.json";
import Link from "next/link";
import { Button } from "@/shared/components/common/button";
import useScroll from "@/shared/hooks/useScroll";
import Skeleton from "@/shared/components/common/Skeleton";

import logo from "@/public/images/logo-persian.webp";

export default function HeaderSkeleton() {
  const {
    header: { nav },
  } = data;

  const { direction } = useScroll();

  return (
    <header
      className={`w-full h-16 flex shadow-sm px-8 border-b bg-background border-white sticky top-0 right-0 left-0 z-10 ${
        direction === "down" && "-translate-y-full"
      } transition duration-200 easeInOutCirc`}
    >
      <Flex className="w-5/6 max-xl:w-full items-center justify-between m-auto">
        {/* Right Side */}
        <Flex className="basis-1/5 max-md:basis-2/4 max-lg:w-1/2 items-center justify-center gap-x-8">
          {/* Logo */}
          <Link href={"/"}>
            <Image
              src={logo}
              priority
              width={28}
              height={10}
              className="w-28"
              alt="logo"
            />
          </Link>
        </Flex>

        <Flex className="basis-3/5 max-lg:hidden items-center justify-center">
          <ul className="flex items-center justify-evenly flex-row gap-x-2">
            {nav.links.map(({ title, link }, i) => (
              <li key={`nav-${i}`}>
                <Link href={link}>
                  <Button
                    variant={"ghost"}
                    className="text-sm text-ghost hover:text-primary font-medium border-none shadow-none! rounded-xs"
                  >
                    {title}
                  </Button>
                </Link>
              </li>
            ))}
          </ul>
        </Flex>

        {/* Left Side */}

        <Flex className="basis-1/5 max-md:basis-1/4  max-lg:w-1/2 justify-center items-center md:gap-x-2 max-md:hidden">
          <Skeleton className="w-28 h-6 rounded-[4px] max-sm:hidden" />

          <Skeleton className="w-28 h-6 rounded-[4px]" />
        </Flex>
      </Flex>
    </header>
  );
}
